<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t("lang.log_template") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="log_template.template_id && log_template.template_id > 0" @invoke-method="refresh(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="log_template.template_id && log_template.template_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('log_templates.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in log_template_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != log_template.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('log_templates.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_log_template.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'log_templates' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container grid-list-xl>
                <v-layout row :wrap="$bp.smallScreen">
                    <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                        <v-layout row wrap>
                            <v-flex xs8 py-0>
                                <!-- <bc-tooltip right v-if="hasPerm('log_templates.update')">
                                    <template slot="activator">
                                        <v-btn
                                            style="text-transform: none"
                                            class="pl-1"
                                            round
                                            selected
                                            :color="log_template.active == '1' ? 'success' : 'error'"
                                            text-color="white"
                                            @mouseup.left="changeStatus()"
                                        >
                                            <v-icon color="white" class="mr-2" v-model="log_template.active">{{
                                                log_template.active == "1" ? "check_circle" : "cancel"
                                            }}</v-icon>
                                            <span class="white--text">{{ log_template.active == "1" ? $t("lang.active") : $t("lang.inactive") }}</span>
                                        </v-btn>
                                    </template>
                                    {{ log_template.active == "1" ? $t("lang.click_to_deactivate") : $t("lang.click_to_activate") }}
                                </bc-tooltip> -->
                            </v-flex>
                            <v-flex xs4 pr-0 py-0>
                                <div class="ml-auto">
                                    <bc-tooltip perm="log_templates.update">
                                        <template slot="activator">
                                            <v-btn @mouseup.left="showLogTemplateDialog(log_template)" icon>
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t("lang.modify_log_template") }}
                                    </bc-tooltip>
                                </div>
                            </v-flex>
                            <v-flex xs12 py-0>
                                <bc-tooltip top :disabled="!hasPerm('log_templates.update')">
                                    <template slot="activator">
                                        <v-img
                                            :src="log_template.image ? log_template.image : getPlaceHolderURI"
                                            :class="{ clickable: hasPerm('log_templates.update') }"
                                            class="mx-auto"
                                            @mouseup.left="hasPerm('log_templates.update') ? pickFile() : ''"
                                            width="150"
                                            height="150"
                                        ></v-img>
                                        <input
                                            :key="reload_file"
                                            type="file"
                                            style="display: none"
                                            ref="image"
                                            accept=".doc, .docx, .xls, .xlsx, .xlsm, .pdf, .jpg, .jpeg, .png, .gif, .tiff, .bmp"
                                            @input="onFilePicked"
                                        />
                                    </template>
                                    {{ $t("lang.uploadImage") }}
                                </bc-tooltip>
                            </v-flex>
                            <v-flex py-1>
                                <p class="display-1 mb-0 text-xs-center">{{ log_template.template_name }}</p>
                                <label class="display-0 mb-0 text-xs-center fs-22">{{ log_template.slug }}</label>
                                <small class="display-0 mb-0 text-xs-center">{{
                                    log_template.version ? `Current Version: ${log_template.version}` : ""
                                }}</small>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                    <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <div class="d-flex" style="align-items: center">
                                    <h2 class="mb-0" style="vertical-align: center; flex: none !important">Questions</h2>
                                    <v-chip
                                        style="flex: none !important"
                                        small
                                        class="ml-2"
                                        color="blue-grey lighten-3"
                                        text-color="white"
                                        disabled
                                        v-if="log_template.log_templates_detail && log_template.log_templates_detail.length > 0"
                                        >{{ log_template.log_templates_detail.length }}</v-chip
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn style="max-width: 128px" @click="openLogTemplateDetailDialog()" color="primary">Add Question</v-btn>
                                </div>
                                <v-divider></v-divider>
                                <v-data-table
                                    :headers="headers"
                                    :items="updating_table == true ? [] : log_template.log_templates_detail || []"
                                    v-sortable-data-table
                                    @sorted="saveOrder"
                                    hide-actions
                                >
                                    <template slot="no-data">
                                        <tr class="text-xs-center">
                                            <td colspan="5" class="text-xs-center">
                                                <v-progress-circular
                                                    v-if="updating_table"
                                                    indeterminate
                                                    color="primary"
                                                    size="24"
                                                    class="mr-2"
                                                ></v-progress-circular>
                                                {{ updating_table == true ? "Refreshing Data..." : "No data available" }}
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td><v-icon class="drag-handle" style="cursor: pointer">drag_indicator</v-icon></td>
                                            <td>
                                                {{ props.item.question }}
                                            </td>
                                            <td>
                                                {{ $getElementType(props.item.element_type).text }}
                                                <br />
                                                <small v-if="props.item.element_type == 'select'">{{ props.item.options }}</small>
                                            </td>
                                            <td>
                                                {{ props.item.required == "1" ? "Required" : "Not Required" }}
                                            </td>
                                            <td>
                                                <div class="d-flex" style="align-items: center">
                                                    <v-btn icon @click="openLogTemplateDetailDialog(props.item)">
                                                        <v-icon color="primary">edit</v-icon>
                                                    </v-btn>
                                                    <v-btn icon @click="openLogTemplateDetailDeleteDialog(props.item)">
                                                        <v-icon color="error">delete</v-icon>
                                                    </v-btn>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <!-- <div class="d-flex" style="position: fixed; bottom: 0; right: 0">
                    <v-spacer></v-spacer>
                    <v-btn @mouseup.left="$router.push({ name: 'log_templates' })" flat>{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @click="saveLogTemplates(false)">{{ $t("lang.save") }}</v-btn>
                </div> -->
            </v-container>
            <bc-dialog :value="log_template_dialog">
                <v-card>
                    <v-form ref="form_log_template">
                        <v-card-title>
                            <span class="headline">{{ log_template.template_id ? $t("lang.edit_log_template") : $t("lang.add_log_template") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeLogTemplateDialog"
                                :dialog-status="log_template_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="log_template_dialog"
                                            v-model="log_template.template_name"
                                            :label="`${$t('lang.template_name')} *`"
                                            :counter="showCounter(log_template.template_name, 'log_templates.template_name')"
                                            :rules="ifValid('log_templates.template_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="log_template.slug"
                                            :label="`${$t('lang.slug')} *`"
                                            :counter="showCounter(log_template.slug, 'log_templates.slug')"
                                            :rules="ifValid('log_templates.slug')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field v-model="log_template.frequency_interval" :label="`${$t('lang.frequency_interval')}`"></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-select
                                            v-model="log_template.frequency"
                                            :items="[
                                                { value: 'minutes', text: 'Minute(s)' },
                                                { value: 'hours', text: 'Hour(s)' },
                                                { value: 'days', text: 'Day(s)' },
                                                { value: 'weeks', text: 'Week(s)' },
                                                { value: 'months', text: 'Month(s)' },
                                                { value: 'years', text: 'Year(s)' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :label="`${$t('lang.frequency')}`"
                                            :rules="ifValid('log_templates.frequency')"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="log_template.capture"
                                            :items="[
                                                { value: null, text: 'None' },
                                                { value: 'machines', text: 'Machines' },
                                                { value: 'parts', text: 'Parts' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :label="`${$t('lang.capture')} *`"
                                            :rules="ifValid('log_templates.capture')"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <!-- <v-btn v-if="log_template.template_id" color="error" @mouseup.left="$refs.delete_log_templates.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn> -->
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeLogTemplateDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveLogTemplates">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="log_template_detail_dialog">
                <v-card>
                    <v-form ref="form_log_template_detail">
                        <v-card-title>
                            <span class="headline">{{ log_template_detail.detail_template_id ? $t("lang.edit_question") : $t("lang.add_question") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeLogTemplateDetailDialog"
                                :dialog-status="log_template_detail_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="log_template_detail_dialog"
                                            v-model="log_template_detail.question"
                                            :label="`${$t('lang.question')} *`"
                                            :counter="showCounter(log_template_detail.question, 'log_templates_detail.question')"
                                            :rules="ifValid('log_templates_detail.question')"
                                            clearable
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="log_template_detail.method"
                                            :label="`${$t('lang.method')}`"
                                            :counter="showCounter(log_template_detail.method, 'log_templates_detail.method')"
                                            :rules="ifValid('log_templates_detail.method')"
                                            clearable
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="log_template_detail.parameter"
                                            :label="`${$t('lang.parameter')}`"
                                            :counter="showCounter(log_template_detail.parameter, 'log_templates_detail.parameter')"
                                            :rules="ifValid('log_templates_detail.parameter')"
                                            clearable
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="log_template_detail.element_type"
                                            :label="`${$t('lang.element_type')} *`"
                                            :items="$getElementType(null, true)"
                                            item-value="type"
                                            item-text="text"
                                            :rules="ifValid('log_templates_detail.element_type')"
                                            @change="setDetailType(log_template_detail.element_type)"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 v-if="log_template_detail.element_type == 'select'">
                                        <v-text-field
                                            v-model="log_template_detail.options"
                                            :label="`${$t('lang.options')} (comma separated)`"
                                            :counter="showCounter(log_template_detail.options, 'log_templates_detail.options')"
                                            :rules="ifValid('log_templates_detail.options')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="log_template_detail.frequency_interval"
                                            :label="`${$t('lang.frequency_interval')}`"
                                            :rules="ifValid('log_templates_detail.frequency_interval')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-select
                                            v-model="log_template_detail.frequency"
                                            :items="[
                                                { value: 'minutes', text: 'Minute(s)' },
                                                { value: 'hours', text: 'Hour(s)' },
                                                { value: 'days', text: 'Day(s)' },
                                                { value: 'weeks', text: 'Week(s)' },
                                                { value: 'months', text: 'Month(s)' },
                                                { value: 'years', text: 'Year(s)' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :label="`${$t('lang.frequency')}`"
                                            :rules="ifValid('log_templates_detail.frequency')"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="log_template_detail.required"
                                            :label="log_template_detail.required == '1' ? 'Required' : 'Not Required'"
                                            true-value="1"
                                            false-value="0"
                                            :required="true"
                                        ></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-switch v-model="keep_editing" label="Keep Editing" true-value="1" false-value="0"></v-switch>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeLogTemplateDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveLogTemplatesDetail()">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <bc-file-upload ref="croppa" :upload-function="handleFileUpload" :removeShadow="true"></bc-file-upload>
            <delete-confirmation-dialog
                ref="delete_log_template"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_log_template')"
                :message="$t('lang.delete_log_template_confirm')"
                @onConfirm="deleteLogTemplates()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_log_template_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="deleteLogTemplateDetail()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import draggable from "vuedraggable";
export default {
    components: {
        draggable,
    },
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            log_template: {},
            file_name: "",
            dbGetLogTemplate: _.debounce(this.getLogTemplate, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            headers: [
                { text: "", sortable: false, width: "2%" },
                { text: "Question", sortable: false, width: "15%" },
                { text: "Element Type", sortable: false, width: "15%" },
                { text: "Required?", sortable: false, width: "10%" },
                { text: "", sortable: false, width: "1%" },
            ],
            element_types: [
                { key: 0, value: "v-text-field", text: "Text Field", rules: "trim" },
                { key: 1, value: "v-select", text: "Select", rules: "trim" },
                { key: 2, value: "v-switch", text: "Switch", rules: "trim" },
                { key: 3, value: "v-text-field", text: "Number", rules: "trim|numeric|max_length[10]" },
                { key: 4, value: "v-decimal", text: "Decimal", rules: "trim" },
            ],
            log_template_dialog: false,
            log_template_detail_dialog: false,
            log_template_detail: {
                question: "",
                element_type: null,
                element_rules: null,
                options: null,
                required: "0",
                detail_template_id: null,
                element_key: null,
            },
            updating_table: false,
            keep_editing: "0",
            reload_file: 0,
            imageName: "",
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchLogTemplate", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.log_templates) {
                        this.log_template = this.assignObj2(data.log_templates, this.rules_log_templates);

                        if (this.log_template.log_templates_detail == null || this.log_template.log_templates_detail.length == 0)
                            this.log_template.log_templates_detail = [];

                        this.log_template.log_templates_detail = this.log_template.log_templates_detail.sort((a, b) => a.sort_order - b.sort_order);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=log_template_status&sort_by=2",
                            method: "get",
                            stateProperty: "log_template_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "log_templates", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchLogTemplate", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.log_templates) {
                        next((vm) => {
                            vm.log_template = vm.assignObj2(data.log_templates, vm.rules_log_templates);

                            if (vm.log_template.log_templates_detail == null || vm.log_template.log_templates_detail.length == 0)
                                vm.log_template.log_templates_detail = [];

                            vm.log_template.log_templates_detail = vm.log_template.log_templates_detail.sort((a, b) => a.sort_order - b.sort_order);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=log_template_status&sort_by=2",
                                method: "get",
                                stateProperty: "log_template_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "log_templates", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_log_templates: (state) => state.log_templates.rules_log_templates,
            rules_log_templates_detail: (state) => state.log_templates.rules_log_templates_detail,
            log_template_status_options: (state) => state.settings.log_template_status_options,
            log_templates: (state) => state.log_templates.log_templates,
            selectedLogTemplate: (state) => state.log_templates.selectedLogTemplate,
        }),
        getPlaceHolderURI() {
            return "https://placehold.co/150x150?text=Log%0ATemplate";
        },
    },
    methods: {
        ...mapActions(["fetchLogTemplate", "saveLogTemplate", "deleteLogTemplate", "printLogTemplate", "saveLogTemplateDetail", "deleteLogTemplatesDetail"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        saveOrder(event) {
            let details = [...this.log_template.log_templates_detail];
            const movedItem = details.splice(event.oldIndex, 1)[0];
            details.splice(event.newIndex, 0, movedItem);

            this.log_template.log_templates_detail = [...details];

            //iterate through the logs and update the sort order
            this.log_template.log_templates_detail.forEach((item, index) => {
                item.sort_order = index + 1;
            });

            this.updating_table = true;
            this.saveLogTemplates(false);
        },
        getLogTemplate(pg_refresh = false) {
            this.startLoader();

            this.fetchLogTemplate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.log_template) {
                    this.log_template = this.assignObj2(data.log_template, this.rules_log_templates);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printLogTemplate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.log_template) {
                    if (this.dev_mode) {
                        this.file_name = data.log_template.file_name;
                    } else {
                        this.$refs.print.printReport(data.log_template.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveLogTemplates(validate = true) {
            this.validationOn();
            this.$nextTick(() => {
                if (validate == true) {
                    if (this.validateForm("form_log_template")) {
                        let body = this.prepForm(this.log_template, this.rules_log_templates);

                        this.saveLogTemplate({
                            body: body,
                        }).then((data) => {
                            if (typeof data != "undefined" && data.log_templates) {
                                this.log_template = this.assignObj2(data.log_templates, this.rules_log_templates);
                                this.log_template.log_templates_detail = this.log_template.log_templates_detail.sort((a, b) => a.sort_order - b.sort_order);
                                setTimeout(() => {
                                    this.updating_table = false;
                                }, 500);
                                this.$root.$emit("escapePressed");
                            } else {
                            }
                        });
                    }
                } else {
                    let body = this.prepForm(this.log_template, this.rules_log_templates);
                    if (!this.$isBase64(body.image)) delete body.image;
                    this.saveLogTemplate({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.log_templates) {
                            this.log_template = this.assignObj2(data.log_templates, this.rules_log_templates);
                            this.log_template.log_templates_detail = this.log_template.log_templates_detail.sort((a, b) => a.sort_order - b.sort_order);
                            setTimeout(() => {
                                this.updating_table = false;
                            }, 500);
                            this.$root.$emit("escapePressed");
                        } else {
                        }
                    });
                }
            });
        },
        saveLogTemplatesDetail() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_log_template_detail")) {
                    let body = this.prepForm(this.log_template_detail, this.rules_log_templates_detail);
                    if (body.element_type == "select" && (body.options != null || body.options != "")) {
                        body.options = body.options
                            .split(",")
                            .map((item) => item.trim())
                            .join(",");
                    }
                    this.saveLogTemplateDetail({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.log_templates_detail) {
                            if (this.keep_editing == "0") {
                                this.closeLogTemplateDetailDialog();
                            }
                            this.refresh(true);
                            this.validationOff();
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus() {
            this.status_loader = true;
            this.log_template.active = this.log_template.active == "1" ? "0" : "1";
            let body = { template_id: `${this.$route.params.id}`, active: this.log_template.active };

            this.saveLogTemplate({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.log_templates) {
                    this.log_template = this.assignObj2(data.log_template, this.rules_log_templates);
                } else {
                    this.$router.push({ name: "log_templates", replace: true });
                }
            });
        },
        deleteLogTemplates() {
            this.deleteLogTemplate({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "log_templates" });
                }
                this.toggleModalLoader(false);
            });
        },
        deleteLogTemplateDetail() {
            this.deleteLogTemplatesDetail({
                id: this.log_template_detail.detail_template_id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.closeLogTemplateDetailDialog();
                    this.refresh(true);
                }
                this.toggleModalLoader(false);
            });
        },
        handleFileUpload(file) {
            this.toggleModalLoader(true);
            this.log_template.image = file;

            this.saveLogTemplates(false);
        },
        onFilePicked(e) {
            const files = e.target.files;
            if (files[0] !== undefined) {
                this.imageName = files[0].name;
                if (this.imageName.lastIndexOf(".") <= 0) {
                    return;
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener("load", () => {
                    this.log_template.image = fr.result;
                    this.saveLogTemplates(false);
                });
            }
        },
        pickFile() {
            this.$refs.image.click();
        },
        showLogTemplateDialog(item) {
            if (this.$refs.form_log_template) item ? this.$refs.form_log_template.resetValidation() : this.$refs.form_log_template.reset();
            this.log_template_dialog = true;
        },
        closeLogTemplateDialog() {
            this.log_template_dialog = false;
            this.$refs.delete_log_template.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        closeLogTemplateDetailDialog() {
            this.log_template_detail_dialog = false;
            this.$refs.delete_log_template_details.close();
            this.validationOff();
            this.toggleModalLoader(false);
            this.log_template_detail = {
                question: "",
                element_type: null,
                element_rules: null,
                options: null,
                required: "0",
                detail_template_id: null,
            };
        },
        openLogTemplateDetailDialog(item = null) {
            if (item != null) {
                this.log_template_detail = this.assignObj2(item, this.rules_log_templates_detail);
            }

            this.log_template_detail.template_id = this.$route.params.id;

            if (this.log_template.log_templates_detail == null || this.log_template.log_templates_detail.length == 0)
                this.log_template.log_templates_detail = [];

            this.log_template_detail_dialog = true;
        },
        openLogTemplateDetailDeleteDialog(item) {
            this.log_template_detail = this.assignObj2(item, this.rules_log_templates_detail);
            this.$refs.delete_log_template_details.openDialog();
        },
        setDetailType(type) {
            let element = this.$getElementType(type, false);
            this.log_template_detail.element_rules = element.rules;
            this.log_template_detail.options = null;
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchLogTemplate({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.log_templates) {
                        this.log_template = this.assignObj2(data.log_templates, this.rules_log_templates);
                        this.log_template.log_templates_detail = this.log_template.log_templates_detail.sort((a, b) => a.sort_order - b.sort_order);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
